<div class="main-content table-page table-page--compact fise-servidores-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Datos de Servidores</h1>
        <p>Administre la infraestructura de FISE desde una vista compacta y consistente.</p>
      </div>

      <button type="button" mat-raised-button class="btn table-page__primary-btn"
        (click)="onClicMostrarModalServidor(null)">
        <i class="material-icons">add</i>
        <span>Agregar Servidor</span>
      </button>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Buscar por IP</mat-label>
              <input aria-label="Buscar por IP" matInput type="text" id="nombreIp" name="nombreIp" maxlength="15" soloip [(ngModel)]="filterIp"
                (ngModelChange)="onFiltroIpChange()" />
            </mat-form-field>
          </div>
        </div>

        <div class="table-page__toolbar-actions">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
            (click)="onClicLimpiar()">
            <span class="material-icons">filter_alt_off</span>
            Limpiar
          </button>
        </div>
      </div>

      <div class="table-page__table-wrap">
        <table class="table-page__table" *ngIf="listServidor.length > 0; else servidoresEmptyState">
          <thead>
            <tr>
              <th>Dirección IP</th>
              <th>Sistema Operativo</th>
              <th>Tipo de Servidor</th>
              <th>Descripción</th>
              <th>Ubicación</th>
              <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let servidorBean of listServidor">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ servidorBean.ip }}</strong>
                  <span class="table-page__subtext">{{ servidorBean.ubicacion || 'Ubicación no definida' }}</span>
                </div>
              </td>
              <td>{{ servidorBean.so || 'Sin definir' }}</td>
              <td>{{ servidorBean.tipoServidor || 'Sin definir' }}</td>
              <td>{{ servidorBean.descripcion || 'Sin descripción' }}</td>
              <td>{{ servidorBean.ubicacion || 'Sin definir' }}</td>
              <td class="table-page__actions table-page__actions--multi">
                <div class="table-page__action-group">
                  <button type="button" class="table-page__action-btn" title="Editar" aria-label="Editar"
                    (click)="onClicMostrarModalServidor(servidorBean)">
                    <i class="material-icons">edit</i>
                  </button>
                  <button type="button" class="table-page__action-btn table-page__action-btn--danger" title="Eliminar"
                    aria-label="Eliminar" (click)="onClicBorrarServidor(servidorBean)">
                    <i class="material-icons">delete</i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #servidoresEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else servidoresLoadingState">
            <i class="material-icons">dns</i>
            <strong>No se encontraron servidores</strong>
            <span>Intente con otra IP o agregue un nuevo servidor desde el botón superior.</span>
          </div>
        </ng-template>

        <ng-template #servidoresLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando servidores...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} servidores</span>
          <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

          <label class="table-page__page-size">
            <span>Ver:</span>
            <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
            Inicio
          </button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="currentPage === 1">
            Anterior
          </button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button *ngIf="isPageNumber(item); else servidoresPagerEllipsis" type="button"
              class="table-page__pager-page" [class.is-current]="item === currentPage" (click)="onPageChange(item)">
              {{ item }}
            </button>

            <ng-template #servidoresPagerEllipsis>
              <span class="table-page__pager-ellipsis">...</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" (click)="nextPage()"
            [disabled]="currentPage === totalPages">
            Siguiente
          </button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()"
            [disabled]="currentPage === totalPages">
            Último
          </button>
        </div>
      </div>
    </section>
  </div>
</div>
